export const sliderArticle = () => {
    if ($("#sliderContainer ul li").length > 1) {
        var timeOut;
        //Cuento la cantidad de slides
        var slides = $("#sliderContainer ul li").length;
        //Creo la navegacion
        nav();
        //Activo la primera
        var pos = 1;
        $('.navegacion span').eq(pos - 1).addClass('activo');

        //Altura flechas
        var alturaContenedor = $('#sliderContainer').height();

        // Funciones a realizar cuando inicia
        slideActiva();
        total();
        epigrafe();
        flechas();

        //Crea la navegacion // VER ESTO QUE NO PEGA LO QUE CREA    
        function nav() {
            for (let i = 0; i < slides; i++) {
                $('.navegacion').append('<span data-slide="slide' + i + '" class="slide-' + i + '"></span>');
            }
        }

        // Activa las flechas
        function flechas() {
            if (pos != 1) {
                $('.galeria .prev').addClass('activo');
                $('.galeria .prev').removeClass('primero');
            } else {
                $('.galeria .prev').removeClass('activo');
                $('.galeria .prev').addClass('primero');
            }
            if (pos != slides) {
                $('.galeria .next').addClass('activo');
                $('.galeria .next').removeClass('ultimo');
            } else {
                $('.galeria .next').removeClass('activo');
                $('.galeria .next').addClass('ultimo');
            }
        }

        //Activa la slide seleccionada
        function slideActiva() {
            $('#sliderContainer ul li').removeClass('activo');
            $('#sliderContainer ul li').addClass('off');
            $('#sliderContainer ul li').removeClass('previo');
            $('#sliderContainer ul li').eq(pos - 2).addClass('previo');
            $('#sliderContainer ul li').eq(pos).removeClass('previo');
            $('#sliderContainer ul li').eq(pos - 1).toggleClass('off activo');
            if (pos == 1) {
                $('#sliderContainer ul li').removeClass('previo');
            }
        }

        //Toma el texto de cada imagen y lo replica
        function epigrafe() {
            var epigrafe = $('#sliderContainer ul li.activo img').attr('alt');
            $('#epigrafe').html(epigrafe);
        }

        // Crea el total y el actual numero de slides
        function total() {
            var total = (pos) + ' de ' + slides;
            $('#total').html(total);
        }
        //Pregunta si es la primera
        function moveLeft() {
            reloadSrc();
            if (pos == 1) {
                pos = slides;
            } else {
                pos = pos - 1;
            }
            slideActiva();
            total();
            flechas();
        };

        //Pregunta si es la ultima
        function moveRight() {
            reloadSrc();
            if (pos == slides) {
                pos = 1;
            } else {
                pos = pos + 1;
            }
            slideActiva();
            total();
            flechas();
        };

        /*stopea el video que se esta reproduciendo y si tiene autoplay se lo quita*/
        function reloadSrc() {
            if ($('#sliderContainer ul li.activo iframe').length) {
                var strReload = $('#sliderContainer ul li.activo iframe').attr('src');
                var strReloadNew = strReload.replace('autoplay=1', 'autoplay=0');
                $('#sliderContainer ul li.activo iframe').attr('src', strReloadNew);
            }
        };

        /*agrega autoplay al video que esta en el elemento visible*/
        function addAutoplay() {
            if ($('#sliderContainer ul li.activo iframe').length) {
                var str = $('#sliderContainer ul li.activo iframe').attr('src');
                var strNew = str.replace('autoplay=0', 'autoplay=1');
                $('#sliderContainer ul li.activo iframe').attr('src', strNew);
            }
        };

        function botonActivo() {
            $('.navegacion span').removeClass('activo');
            $('.navegacion span').eq(pos - 1).addClass('activo');
        };

        /*los botones ejecutan las funciones anteriores*/
        $(".prev").click(function() {
            moveLeft();
            botonActivo();
            addAutoplay();
            total();
            epigrafe();
            flechas();
        });

        $(".next").click(function() {
            moveRight();
            botonActivo();
            addAutoplay();
            total();
            epigrafe();
            flechas();
        });

        //Activa el slide segun la posicion del menu
        $(".navegacion span").click(function() {
            reloadSrc();
            pos = $(this).attr("data-slide");
            pos = parseInt(pos);
            botonActivo();
            slideActiva();
            addAutoplay();
            total();
            epigrafe();
            flechas();
        });
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/home/slideArticleHome.js